import { Shield, Star, Crown, User, ShieldCheck } from "lucide-react";

const MEMBERSHIP_CONFIG = {
  basic: { label: "일반", icon: User, color: "text-stone-500", bgColor: "bg-stone-50 border-stone-200" },
  regular: { label: "정회원", icon: Shield, color: "text-emerald-600", bgColor: "bg-emerald-50 border-emerald-200" },
  standard: { label: "정회원", icon: Shield, color: "text-emerald-600", bgColor: "bg-emerald-50 border-emerald-200" },
  // premium 등급은 '프리미엄'으로 별도 표기
  premium: { label: "프리미엄", icon: Star, color: "text-rose-600", bgColor: "bg-rose-50 border-rose-200" },
  vip: { label: "VIP", icon: Crown, color: "text-purple-600", bgColor: "bg-purple-50 border-purple-200" },
  // 구버그 보정: membership_type='annual' 잔존 회원도 정회원으로 표기
  annual: { label: "정회원", icon: Shield, color: "text-emerald-600", bgColor: "bg-emerald-50 border-emerald-200" },
};

export const MembershipBadge = ({ membership, size = "sm" }) => {
  const config = MEMBERSHIP_CONFIG[membership] || MEMBERSHIP_CONFIG.basic;
  if (!config.icon) return null;

  const Icon = config.icon;
  const isSmall = size === "sm";

  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded-full border font-medium ${config.bgColor} ${config.color} ${
        isSmall ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"
      }`}
      data-testid={`membership-badge-${membership}`}
    >
      <Icon className={isSmall ? "w-2.5 h-2.5" : "w-3 h-3"} />
      {config.label}
    </span>
  );
};

export const MembershipIcon = ({ membership, className = "" }) => {
  const config = MEMBERSHIP_CONFIG[membership] || MEMBERSHIP_CONFIG.basic;
  if (!config.icon) return null;

  const Icon = config.icon;
  return <Icon className={`${config.color} ${className}`} />;
};

export const DocumentVerifiedBadge = ({ verified, size = "sm" }) => {
  if (!verified) return null;
  const isSmall = size === "sm";
  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded-full border font-semibold bg-gradient-to-r from-cyan-50 to-teal-50 border-cyan-300 text-cyan-700 shadow-sm ${
        isSmall ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"
      }`}
      data-testid="document-verified-badge"
      title="혼인관계증명서 인증 완료"
    >
      <ShieldCheck className={isSmall ? "w-2.5 h-2.5" : "w-3 h-3"} />
      인증
    </span>
  );
};

export default MembershipBadge;
